import React, { useState } from 'react';
import Slider from '@mui/material/Slider';
import CommonTypography from '@src/new-components/Typography';
import useNumberDraft from './useNumberDraft';
import { StyledSliderField } from './index.style';

const SliderField = ({ width, value, range, suffix, onChange }) => {
  // Giữ giá trị đang kéo ở đây và chỉ đẩy ra ngoài khi thả tay. Bắn theo từng
  // bước kéo sẽ dồn hàng loạt action qua reducer và middleware lịch sử.
  const [dragging, setDragging] = useState(null);
  const current = dragging ?? value;
  const draft = useNumberDraft(current, range, onChange);

  return (
    <StyledSliderField $width={width}>
      <Slider
        className="slider-field-track"
        value={current}
        min={range.MIN}
        max={range.MAX}
        onChange={(event, next) => setDragging(next)}
        onChangeCommitted={(event, next) => {
          setDragging(null);
          if (next !== value) onChange(next);
        }}
      />
      <div className="slider-field-value">
        <input {...draft} />
        {suffix && (
          <CommonTypography
            className="slider-field-suffix"
            variant="body-14-medium"
          >
            {suffix}
          </CommonTypography>
        )}
      </div>
    </StyledSliderField>
  );
};

export default SliderField;
